import React from "react";
import PageTemplate from "../components/PageTemplate";

function Drinks() {
  return (
    <PageTemplate title="Drinks">
      <p>Shake, stir, and sip — cocktails and drinks coming soon!</p>
    </PageTemplate>
  );
}

export default Drinks;
